module.exports = __webpack_public_path__ + "img/393562264d663d5050116504e4fa475b.1c9cc99b.jpg";